var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "BarChart" }, [
    _c("div", { staticClass: "bar" }, [
      _c("div", {
        staticClass: "progress",
        style: "width:" + _vm.currentValue + "%;background-color:" + _vm.color
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }